import React from 'react'
import presenceTypes from '../presenceTypes'

export default function PresenceButtonLabel({ presence }) {
  const { name = 'Unknown', className } = presenceTypes[presence] || {}

  return <span className={className}>{name}</span>
}
